import {Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';

export interface GenericCabin {
  id: number;
  generic_id: number;
  name: string;
  codes: string[];
  color: string;
}

@Injectable({providedIn: 'root'})
export class CabinsService {
  path: string = '/api';
  cabinsMap: GenericCabin[] = [
    {
      id: 1,
      generic_id: 1,
      name: 'Economy',
      codes: ['Y', 'P'],
      color: '#349068',
    },
    {
      id: 2,
      generic_id: 2,
      name: 'Premium Economy',
      codes: ['W'],
      color: '#714f96',
    },
    {
      id: 3,
      generic_id: 3,
      name: 'Business',
      codes: ['C'],
      color: '#c48b06',
    },
    {
      id: 4,
      generic_id: 4,
      name: 'First',
      codes: ['F'],
      color: '#d85826',
    },
  ];

  getCabins(): GenericCabin[] {
    // NOTE: this api method is no longer working
    return this.cabinsMap;
  }

  getCabinsObservable(): Observable<GenericCabin[]> {
    return of(this.cabinsMap);
  }

  getCabinColors() {
    return [
      {
        color: '#349068',
        codes: ['Y', 'P'],
        id: 1,
      },
      {
        color: '#714f96',
        codes: ['W'],
        id: 2,
      },
      {
        color: '#c48b06',
        codes: ['C'],
        id: 3,
      },
      {
        color: '#d85826',
        codes: ['F'],
        id: 4,
      },
    ];
  }
}
